import AutoComplete from 'vuejs-auto-complete'
import Order from './attrs/components/Order/Index'

import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'

export default {
    name: 'OrderList',
    created,
    data,
    methods,
    components: {
        Order,
        AutoComplete
    }
}
